
import {getLocalId} from 'utils/localId';
import {Endpoints, postValues} from 'utils/n8n';

import {calcRegion} from './calcRegion';
import {Action, Configs} from './types';

export const reducer = (state: Configs, action: Action): Configs => {
	switch (action.type) {
	case 'SET-REGION':
		if (action.skipIf === 'set') {
			if (state.region) {
				return {...state};
			}
		}

		return {
			...state,
			coords: action.region?.center,
			region: action.region,
			label: action.region?.name,
			sortBy: 'DISTANCE',
		};

	case 'SET-COORDS': {
		const region = calcRegion(action.coords);

		// If we already have a region, only update
		// if these coordinates are within that region
		if (action.skipIf === 'mismatched') {
			if (state.region && region &&
				state.region.key !== region?.key) {
				return {...state};
			}
		}

		// Save information for analysis
		if (action.label && action.coords) {
			postValues(Endpoints.userGPS, {
				uniq: getLocalId(),
				name: action.label,
				region: region?.key || '',
				coords: action.coords,
			});
		}

		return {
			...state,
			coords: action.coords,
			region,
			label: action.label,
			sortBy: 'DISTANCE',
		};
	}

	case 'SET-USER-COORDS':
		return {
			...state,
			userCoords: action.coords,
			userLabel: action.label,
		};

	case 'CLEAR-SEARCH':
		return {
			userCoords: state.userCoords,
			userLabel: state.userLabel,
		};

	case 'TOGGLE-MAP':
		return {
			...state,
			showMap: !state.showMap,
		};

	case 'SET-SORT':
		return {
			...state,
			sortBy: action.sort,
		};
	}
};
